const transposedDataToSeries = (config, data, columns, labels) => {
  const {
    band,
    series,
    data: value
  } = config.series;
  const bandIdx = columns.findIndex((col) => col.key === band.key);
  const seriesIdx = columns.findIndex((col) => col.key === series.key);
  const valueIdx = columns.findIndex((col) => col.key === value.key);
  if ([bandIdx, seriesIdx, valueIdx].some((idx) => idx === -1)) {
    throw new Error("One or more required column keys are missing in the dataset.");
  }
  const seriesMap = {};
  const bands = /* @__PURE__ */ new Set();
  for (const row of data) {
    const bandKey = row[bandIdx];
    const seriesKey = row[seriesIdx];
    const rawValue = row[valueIdx];
    const numericValue = typeof rawValue === "number" ? rawValue : Number(rawValue ?? 0);
    bands.add(bandKey);
    if (!seriesMap[seriesKey]) {
      seriesMap[seriesKey] = {
        label: labels[seriesKey] || seriesKey,
        data: {},
        stack: "total",
        type: "bar",
        columnKey: value.key
      };
    }
    seriesMap[seriesKey].data[bandKey] = numericValue;
  }
  const bandOrder = Array.from(bands);
  const dataset = Object.values(seriesMap).map((series2) => ({
    ...series2,
    data: bandOrder.map((band2) => series2.data[band2] ?? 0)
  }));
  return dataset;
};
const transposeRowsToSeries = ({
  series
}, data, columns, labels) => series.map((seriesItem) => {
  const dataKey = seriesItem.data.key;
  const valueIdx = columns.findIndex((col) => col.key === dataKey);
  if (valueIdx === -1) {
    throw new Error(`Data key '${dataKey}' not found in columns`);
  }
  const label = typeof seriesItem.label === "string" ? seriesItem.label : labels[seriesItem.label?.key ?? dataKey] ?? seriesItem.label?.key ?? dataKey;
  return {
    label,
    columnKey: dataKey,
    data: data.map((row) => {
      const value = row[valueIdx];
      return typeof value === "number" ? value : Number(value ?? 0);
    }),
    type: seriesItem.type === "line" || seriesItem.type === "area" ? "line" : "bar",
    ...seriesItem.type === "line" || seriesItem.type === "area" || seriesItem.type === "bar" ? {} : {
      stack: "total"
    },
    ...seriesItem["y-axis"] !== void 0 ? {
      yAxisId: seriesItem["y-axis"]
    } : {},
    ...seriesItem.type === "area" ? {
      area: true
    } : {}
  };
});
export {
  transposeRowsToSeries,
  transposedDataToSeries
};
